import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ShareService } from './../services/services';
import {Roomlisting,RoomlistingService } from './roomlisting.services';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { AlertService} from './../services/alert.service';
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
}

let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let hotemodel;



if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    
    
    if(jsonObject.hotel)
    {
	    hotemodel=true;
    }
    else
    {
	    hotemodel=false;
    }
}
//console.log("hoteldata"+hotemodel);
let componentdata;
if(hotemodel)
{
   
	//template: require('./contacthome.component.html')
	componentdata={templateUrl: './pg/hotel/booking.component.html'}
	//templateUrl: './pg/hotel/roombooking.component.html',
}
else
{
    
   componentdata={template: '<div></div>'}

   
}
@Component(componentdata)

export class BookingComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	PaymentForm: FormGroup;
	public apiData;
	public metatitle;
    public metadescription;
    public category;    
    public categorylist:Array<any>;
    public bookingdetail:Array<any>;
    public paymentinfo;
    public params;
    public grand_total;    
    public roombookqty=0;
    public partialpaymentamt=0;
    public checkindate;
	public checkoutdate;
    public showbtn=true;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private alertService: AlertService,
	    private slimLoadingBarService: SlimLoadingBarService,
	    public fb: FormBuilder,
	    private _pageService: RoomlistingService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}	
	      this.PaymentForm = fb.group({
       'payment_type': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
      'firstname': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
      'address1': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
      'city': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
      'state': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
      'lastname': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
      'address2': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
      'zipcode': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
       'country': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
       'phone': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
       'email': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ],
       'terms': [
        '',
        Validators.compose([Validators.required,Validators.minLength(5)])
      ]
      
      
    });  
	    }

	ngOnInit() {
	
	
	     
	     this.bookingdetail=this.shareService.getbookingdetail();
	     this.paymentinfo=this.shareService.getPaymentinfo();
	       console.log("paymentinfo->"+JSON.stringify(this.paymentinfo));	 
	       this._title.setTitle("Booking");
	       
	       
	     if(this.shareService.getbookingdetail()==undefined)
	     {
		     this._router.navigate(['./h/booking']);
	     }
	     let bookingrow =this.shareService.getbooking();
	     let checkindate;
		 let checkoutdate;
		 let adultpersion;
		 let children;
			// console.log(this.shareService.getbooking());
			if(this.shareService.getbooking()!=undefined)
			{
				checkindate=bookingrow.checkin;
				checkoutdate=bookingrow.checkout;
				adultpersion=bookingrow.adult;
				children=bookingrow.child;
				
				//console.log('inside');
				
			}
				
			//}
			 if(checkindate==undefined)
			 {
				 checkindate=this.currentdate();
				 checkoutdate=this.nextdate();
				 //console.log('inside');
				 
				 
			 }

	     this.checkindate=checkindate;
		 this.checkoutdate=checkoutdate;
		 
		 this.grand_total=this.shareService.getgrandtotal();
		 //console.log(this.paymentinfo.length);
		if(this.paymentinfo!=undefined)
	      {
		      this.partialpaymentamt=(Number(this.paymentinfo.online_hotel_pay)/100)*this.grand_total;
		      console.log(this.partialpaymentamt);
		      

		      
		      
	      }
		 
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	   // this.slimLoadingBarService.start();
	
		
	
		
	}

    ngOnDestroy() {
       //this._sub.unsubscribe();
    }
    
    
    PaymentValidate(): boolean {
   
  if (this.PaymentForm.valid) {
    return true;
  }
  let errorMsg = '';
  

  let field_payment_type = this.PaymentForm.controls['payment_type'];
  if (!field_payment_type.valid) {
    if (field_payment_type.errors['required']) {
      errorMsg = 'Please Choose Payment Option<br />';
    }
  }
  

  let field_firstname = this.PaymentForm.controls['firstname'];
  if (!field_firstname.valid) {
    if (field_firstname.errors['required']) {
      errorMsg = errorMsg+'Provide your First Name.<br />';
    }
  }
  
  let field_lastname = this.PaymentForm.controls['lastname'];
  if (!field_lastname.valid) {
    if (field_lastname.errors['required']) {
      errorMsg = errorMsg+'Provide your Last Name.<br />';
    }
  }
  
  let field_address1 = this.PaymentForm.controls['address1'];
  if (!field_address1.valid) {
    if (field_address1.errors['required']) {
      errorMsg = errorMsg+'Provide your Address<br />';
    }
  }
  
  let field_city = this.PaymentForm.controls['city'];
  if (!field_city.valid) {
    if (field_city.errors['required']) {
      errorMsg = errorMsg+'Provide your City<br />';
    }
  }
  
  let field_state = this.PaymentForm.controls['state'];
  if (!field_state.valid) {
    if (field_state.errors['required']) {
      errorMsg = errorMsg+'Provide your State<br />';
    }
  }
  
  let field_phone = this.PaymentForm.controls['phone'];
  if (!field_phone.valid) {
    if (field_phone.errors['required']) {
      errorMsg = errorMsg+'Provide your Contact Number<br />';
    }
  }
  let field_email = this.PaymentForm.controls['email'];
  if (!field_email.valid) {
    if (field_email.errors['required']) {
      errorMsg = errorMsg+'Provide your Email<br/>';
    }
  }
  
  let field_terms = this.PaymentForm.controls['terms'];
  if (!field_terms.valid) {
    if (field_terms.errors['required']) {
      errorMsg = errorMsg+'Please Check Our Terms and Conditions<br/>';
    }
  }
  
  
  
 if(errorMsg!="")
 {
    //alert(errorMsg);
    window.scrollTo(10, 0);
    this.alertService.error(errorMsg);
    
  return false;
  }
  else
  {
    return true;
  }
}
    
    
 doPayment(event) {
       

     if (this.PaymentValidate())
      {
    
            let payment_type = this.PaymentForm.controls['payment_type'].value;
			let firstname = this.PaymentForm.controls['firstname'].value;
	        let lastname = this.PaymentForm.controls['lastname'].value;
	        let address1 = this.PaymentForm.controls['address1'].value;
	        let address2 = this.PaymentForm.controls['address2'].value;
	        let city = this.PaymentForm.controls['city'].value;
	        let state = this.PaymentForm.controls['state'].value;
	        let zipcode = this.PaymentForm.controls['zipcode'].value;
	        let country = this.PaymentForm.controls['country'].value;
	        let phone = this.PaymentForm.controls['phone'].value;
	        let email = this.PaymentForm.controls['email'].value; 
	        
	        let checkindate=this.checkindate;
	        
	        let checkoutdate=this.checkoutdate;
	        let grand_total=this.shareService.getgrandtotal();
	        let bookingdata=this.shareService.getbookingdetail();
	        this.params = {
                 
                  payment_type: payment_type,
                  firstname: firstname,
                  lastname: lastname,
                  address1:address1,
                  address2:address2,
                  country:country,
                  city:city,
                  state:state,
                  zipcode:zipcode,
                  phone:phone,
                  email:email,
                  checkindate:checkindate,
                  checkoutdate:checkoutdate,
                  bookingdata:bookingdata,                  
                  grand_total:grand_total
                  
                };
	        
	        this._pageService.doBooking(this.params,bookingdata).subscribe(
        data => {
            this.apiData = data;
            // loading.dismiss();
            this.alertService.success(this.apiData.message);
            window.scrollTo(10, 0);
            
             this.reset();
        },
        err => console.error(err),
        () => console.log('services completed')
    );

	        
             
           
     }
              
               
               
              
  
    
     }
    
    
    reset() {
     this.PaymentForm.reset();
       }
             
   public backtobooking()
   {
	   this._router.navigate(['./h/booking']);
   }
   currentdate()
    {
	    var date = new Date();
		return ('0' + date.getDate()).slice(-2)+ '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();


    }
    nextdate()
    {
	   var date = new Date();
	   var day=Number(date.getDate())+1;
	  return ('0' +day).slice(-2)+ '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/hotel/booking.component.ts